/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SecurityLabelDto } from './SecurityLabelDto';
import {
    SecurityLabelDtoFromJSON,
    SecurityLabelDtoFromJSONTyped,
    SecurityLabelDtoToJSON,
    SecurityLabelDtoToJSONTyped,
} from './SecurityLabelDto';
import type { TimezoneMetadata } from './TimezoneMetadata';
import {
    TimezoneMetadataFromJSON,
    TimezoneMetadataFromJSONTyped,
    TimezoneMetadataToJSON,
    TimezoneMetadataToJSONTyped,
} from './TimezoneMetadata';

/**
 * 
 * @export
 * @interface SecurityLabelListResponse
 */
export interface SecurityLabelListResponse {
    /**
     * 
     * @type {string}
     * @memberof SecurityLabelListResponse
     */
    userTimezone?: string;
    /**
     * Indicates if the request was successful
     * @type {boolean}
     * @memberof SecurityLabelListResponse
     */
    success?: boolean;
    /**
     * Error message if the request failed
     * @type {string}
     * @memberof SecurityLabelListResponse
     */
    error?: string;
    /**
     * 
     * @type {TimezoneMetadata}
     * @memberof SecurityLabelListResponse
     */
    timezoneMetadata?: TimezoneMetadata;
    /**
     * 
     * @type {Array<SecurityLabelDto>}
     * @memberof SecurityLabelListResponse
     */
    data?: Array<SecurityLabelDto>;
    /**
     * 
     * @type {number}
     * @memberof SecurityLabelListResponse
     */
    total?: number;
    /**
     * 
     * @type {number}
     * @memberof SecurityLabelListResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof SecurityLabelListResponse
     */
    pageSize?: number;
}

/**
 * Check if a given object implements the SecurityLabelListResponse interface.
 */
export function instanceOfSecurityLabelListResponse(value: object): value is SecurityLabelListResponse {
    return true;
}

export function SecurityLabelListResponseFromJSON(json: any): SecurityLabelListResponse {
    return SecurityLabelListResponseFromJSONTyped(json, false);
}

export function SecurityLabelListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SecurityLabelListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'userTimezone': json['userTimezone'] == null ? undefined : json['userTimezone'],
        'success': json['success'] == null ? undefined : json['success'],
        'error': json['error'] == null ? undefined : json['error'],
        'timezoneMetadata': json['timezone_metadata'] == null ? undefined : TimezoneMetadataFromJSON(json['timezone_metadata']),
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(SecurityLabelDtoFromJSON)),
        'total': json['total'] == null ? undefined : json['total'],
        'page': json['page'] == null ? undefined : json['page'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
    };
}

export function SecurityLabelListResponseToJSON(json: any): SecurityLabelListResponse {
    return SecurityLabelListResponseToJSONTyped(json, false);
}

export function SecurityLabelListResponseToJSONTyped(value?: SecurityLabelListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userTimezone': value['userTimezone'],
        'success': value['success'],
        'error': value['error'],
        'timezone_metadata': TimezoneMetadataToJSON(value['timezoneMetadata']),
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(SecurityLabelDtoToJSON)),
        'total': value['total'],
        'page': value['page'],
        'pageSize': value['pageSize'],
    };
}

